import { Typography } from '@mui/material';
import { formatPostnummer } from '../../../common/lib/formatPostnummer';
import {
  Adress as AdressModel,
  BostadsinformationDto,
} from '../../types/dtos/VarderingarModel';
import styles from './Adress.module.css';
import { Adressrader } from './Adressrader';

interface AdressProps {
  bostadsinfo: BostadsinformationDto;
}

export const Adress: React.FC<AdressProps> = ({ bostadsinfo }) => (
  <div className={styles.row}>
    <div className={styles.item} style={{ width: '233px' }}>
      <Typography variant="subtitle1">Vald adress</Typography>
      <Adressrader adress={createAdress(bostadsinfo)} />
    </div>
    <div className={styles.item} style={{ width: '235px' }}>
      <Typography variant="subtitle1">Koordinater (SWEREF 99 TM)</Typography>
      {bostadsinfo?.sweref99x && bostadsinfo?.sweref99y && (
        <>
          <Typography variant="body1">N: {bostadsinfo.sweref99y}</Typography>
          <Typography variant="body1">E: {bostadsinfo.sweref99x}</Typography>
        </>
      )}
    </div>
  </div>
);

const createAdress = (bostad?: BostadsinformationDto): AdressModel => {
  if (!bostad) {
    return undefined;
  }
  const gata = bostad.adress;
  const lagenhetsnummer = bostad.lagenhetsnummer || '';
  const postnummer = bostad.postnummer
    ? formatPostnummer(bostad.postnummer)
    : '';
  const postort = bostad.postort || '';
  return { gata, lagenhetsnummer, postnummer, postort };
};
